export default "__VITE_ASSET__Yn8qQyLs__"